import { confirmAlert } from 'react-confirm-alert';

import type { DepartmentId } from '@vlabs/api/artemy/model';

import { DeleteDepartmentsConfirmation } from './DeleteDepartmentsConfirmation';

interface ConfirmDeleteDepartmentsProps {
  departmentIds: DepartmentId[];
}

type ConfirmDeleteDepartmentsResult = 'confirmed' | 'cancelled';

async function confirmDeleteDepartments({
  departmentIds,
}: ConfirmDeleteDepartmentsProps): Promise<ConfirmDeleteDepartmentsResult> {
  return new Promise((resolve) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <DeleteDepartmentsConfirmation
            departmentIds={departmentIds}
            onConfirm={() => {
              resolve('confirmed');
              onClose();
            }}
            onReject={() => {
              resolve('cancelled');
              onClose();
            }}
          />
        );
      },
    });
  });
}

export { confirmDeleteDepartments };
export type { ConfirmDeleteDepartmentsResult };
